import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment/build/index';
import Select from 'react-select';

import Api from '../../../../libraries/api';
import AuthHelper from '../../../../libraries/auth-helper';
import Button from '@material-ui/core/Button';
import ErrorHandling from '../../../../libraries/error-handling';
import { toast, ToastContainer } from 'react-toastify';
import { history } from '../../../../shared/configure-store';
import { LEAVE_TYPES, HR_OVERVIEW_ROLES } from './constants';

require('dotenv').config();
const validator = new SimpleReactValidator({ locale: process.env.REACT_APP_LOCALE });

class UserLeavesAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingButton: false,
            errors: {},
            enableOverview: true,
            users: [],
            user_id: null,
            leave_type: '',
            start_date: null,
            end_date: null,
            leaveTypes: LEAVE_TYPES,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Apply Leave';
        this.__initProfile();
        this.__fetchMeta();
    }

    __fetchMeta = () => {
        Api.get('/user-leaves?limit=1&page=1').then(resp => {
            if (resp?.meta?.custom?.leaveTypes) {
                this.setState({ leaveTypes: resp.meta.custom.leaveTypes });
            }
        });
    };

    __initProfile = () => {
        const profile = AuthHelper.getProfile();
        const enableOverview = true; // DEVNOTE: All user can access this page
        // const enableOverview = HR_OVERVIEW_ROLES.includes(profile?.role);

        if (enableOverview) {
            this.setState({ enableOverview }, () => {
                this.__fetchUsers();
            });
        } else if (profile?.id) {
            this.setState({
                user_id: { value: profile.id, label: profile.name },
            });
        }
    };

    __fetchUsers = () => {
        Api.get('/users?limit=0').then(resp => {
            if (resp?.data) {
                const users = resp.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                this.setState({ users });
            }
        });
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    handleDate = (date, prop) => {
        this.setState({ [prop]: date });
    };

    handleUserChange = (selected) => {
        this.setState({ user_id: selected });
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        if (moment(this.state.end_date).diff(moment(this.state.start_date)) < 0) {
            this.showMessage(false, 'End date must be on or after start date');
            return false;
        }

        this.setState({ errors: {}, loadingButton: true });

        const params = {
            user_id: this.state.user_id?.value,
            leave_type: this.state.leave_type,
            start_date: moment(this.state.start_date).format('YYYY-MM-DD'),
            end_date: moment(this.state.end_date).format('YYYY-MM-DD'),
        };

        Api.post('/user-leaves', params, false).then((resp) => {
            const id = resp?.data?.id;
            if (!id) {
                return Promise.reject({ message: 'Missing leave id' });
            }
            return Api.patch('/user-leaves/' + id + '/status', { status: 'Approved' }, false);
        }).then(() => {
            this.setState({ loadingButton: false });
            history.push('/user-leaves');
            this.showMessage(true, 'Leave request submitted');
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
            } else {
                this.setState({ errors: err.errors || {}, loadingButton: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    handleGo = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Apply Leave</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/user-leaves">User Leaves</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Apply</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper ">
                        <form name="add" id="addLeave" className="row" noValidate>
                            {this.state.enableOverview && (
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Name</label>
                                    <Select
                                        options={this.state.users}
                                        onChange={this.handleUserChange}
                                        value={this.state.user_id}
                                        isClearable
                                        isSearchable
                                        styles={{
                                            menu: (baseStyles) => ({ ...baseStyles, zIndex: 3 }),
                                        }}
                                    />
                                    {validator.message('user_id', this.state.user_id?.value, 'required')}
                                    <div className="text-danger">{this.state.errors.user_id}</div>
                                </div>
                            </div>
                            )}
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Leave Type</label>
                                    <TextField
                                        variant="outlined"
                                        select
                                        id="leave_type"
                                        name="leave_type"
                                        label="Leave Type"
                                        onChange={(e) => this.handleChange(e, 'leave_type')}
                                        value={this.state.leave_type}
                                        fullWidth
                                    >
                                        {this.state.leaveTypes.map(option => (
                                            <MenuItem key={option} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    {validator.message('leave_type', this.state.leave_type, 'required')}
                                    <div className="text-danger">{this.state.errors.leave_type}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Start Date</label>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            label="Start Date"
                                            value={this.state.start_date}
                                            onChange={(date) => this.handleDate(date, 'start_date')}
                                            format="DD MMM YYYY"
                                            cancelLabel="BATAL"
                                            inputVariant="outlined"
                                            autoOk
                                        />
                                    </MuiPickersUtilsProvider>
                                    {validator.message('start_date', this.state.start_date, 'required')}
                                    <div className="text-danger">{this.state.errors.start_date}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>End Date</label>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            label="End Date"
                                            value={this.state.end_date}
                                            onChange={(date) => this.handleDate(date, 'end_date')}
                                            format="DD MMM YYYY"
                                            cancelLabel="BATAL"
                                            inputVariant="outlined"
                                            autoOk
                                        />
                                    </MuiPickersUtilsProvider>
                                    {validator.message('end_date', this.state.end_date, 'required')}
                                    <div className="text-danger">{this.state.errors.end_date}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button
                                    variant="contained"
                                    className="mr-3"
                                    onClick={() => this.handleGo('/user-leaves')}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton && 'disabled'}
                                >
                                    Submit{this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        );
    }
}

export default UserLeavesAdd;
